

import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateRouteItem } from "../../../../../../features/updateLoad/updateLoadSlice"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import moment from "moment"
import dateConverter from "../../../../../../helper/dateConverter"

const Container = styled.div`
    width: 220px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};
        border-color: ${({showErrors}) => showErrors && "var(--color-red)"};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }
`

const BosaltmaDateInput = ({data, name, isRequired}) => {

    const [text, setText] = useState(moment(data.date).format("YYYY-MM-DD"))
    const {showErrors, showRequiredPlaces} = useSelector(state => state.updateLoad)
    const [isError, setIsError] = useState(false)

    const dispatch = useDispatch()

    const handleChange = (e) => {
        setText(e.target.value)

        const updatedItem = {
            id: data.id,
            date: e.target.value
        }
        
        dispatch(updateRouteItem(updatedItem))
    }

    useEffect(()=> {
        setText(data.date)
    },[data.date])

    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && !data.date && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data.date, showRequiredPlaces, showErrors])

  return (
    <Container value={text} radius={"5px"} isError={isError}>
        <input type="date" id={"text"} onChange={handleChange} value={dateConverter(text, "us")} name={name}/> 
        <label htmlFor={"text"}>Boşaltma Tarihi</label>
    </Container>
  )
}

export default BosaltmaDateInput